import { MarketStatuses } from 'constants/app';
import { MarketDefinitionRunnerStatuses } from 'constants/marketGraph';
import { AppState } from 'redux/reducers';

export const getMarketDefinitionInPlayStatus =
  (marketId: string) =>
  ({ marketDefinitions }: AppState) =>
    !!marketDefinitions.markets?.[marketId]?.inPlay;

export const getMarketDefinitionTurnInPlayEnabled =
  (marketId: string) =>
  ({ marketDefinitions }: AppState) =>
    !!marketDefinitions.markets?.[marketId]?.turnInPlayEnabled;

export const getMarketDefinitionSelectionStatuses =
  (marketId: string) =>
  ({ marketDefinitions }: AppState) =>
    marketDefinitions.markets?.[marketId]?.runners;

export const getMarketDefinitioLineRangeInfo =
  (marketId: string) =>
  ({ marketDefinitions }: AppState) =>
    marketDefinitions.markets?.[marketId]?.lineRangeInfo;

export const getMarketDefinitionMarketUnit =
  (marketId: string) =>
  ({ marketDefinitions }: AppState) =>
    marketDefinitions.markets?.[marketId]?.lineRangeInfo?.marketUnit;

export const getIsMarketDefinitionMarketClosed =
  (marketId: string) =>
  ({ marketDefinitions }: AppState) =>
    marketDefinitions.markets?.[marketId]?.status === MarketStatuses.CLOSED;

export const getIsMarketDefinitionSelectionClosed =
  ({ marketId, selectionId, handicap }: { marketId: string; selectionId: number; handicap: number }) =>
  ({ marketDefinitions }: AppState) => {
    const runnerStatus = marketDefinitions.markets?.[marketId]?.runners?.find(runner => {
      if (runner.hc === undefined) {
        return runner.id === selectionId;
      }

      return runner.id === selectionId && runner.hc === handicap;
    })?.status;

    return !!runnerStatus && runnerStatus !== MarketDefinitionRunnerStatuses.ACTIVE;
  };

export const getMarketDefinitionIsMarketDisabled =
  (marketId: string) =>
  ({ marketDefinitions }: AppState) => {
    const isEnabled = marketDefinitions.markets?.[marketId]?.enabled;

    return typeof isEnabled === 'boolean' && !isEnabled;
  };
